import React from 'react';
import { bindActionCreators } from 'redux';

import {
  actions as routingActions,
  types as routingTypes,
} from './ducks/routing.js';
import { getString } from './helpers/stringHelpers.js';
import { isFeatureDisabled } from './helpers/outageHelpers';

import HomeIcon from '@material-ui/icons/HomeOutlined';
import WellbeingIcon from '@material-ui/icons/Mood';
import AccountsIcon from '@material-ui/icons/AccountBalanceOutlined';
import MaintenanceIcon from '@material-ui/icons/BuildOutlined';
import AppointmentsIcon from '@material-ui/icons/DateRangeOutlined';
import ProfileIcon from '@material-ui/icons/PermIdentity';
import LettersIcon from '@material-ui/icons/MailOutline';
import ServicesIcon from '@material-ui/icons/PhoneAndroid';
import ApplyIcon from '@material-ui/icons/DescriptionOutlined';
import PhoneIcon from '@material-ui/icons/PhoneOutlined';
import HelpIcon from '@material-ui/icons/HelpOutline';

import CircleNumber from './components/CircleNumber/CircleNumber.js';
import constants from './constants';

function configureDrawerMap(
  currentPage,
  dispatch,
  appointments = 0,
  letters = 0,
  roles = []
) {
  const bindRouteAction = (action, params) => () =>
    bindActionCreators(action, dispatch)();

  const appointmentsTitle =
    appointments > 0 ? (
      <div>
        {getString('drawer', 'APPOINTMENTS_TITLE')}{' '}
        <CircleNumber number={appointments} />
      </div>
    ) : (
      getString('drawer', 'APPOINTMENTS_TITLE')
    );

  const lettersTitle =
    letters > 0 ? (
      <div>
        {getString('drawer', 'LETTERS_TITLE')} <CircleNumber number={letters} />
      </div>
    ) : (
      getString('drawer', 'LETTERS_TITLE')
    );

  return [
    {
      name: 'home',
      title: getString('drawer', 'HOME_TITLE'),
      breadcrumbTitle: getString('drawer', 'HOME_BREADCRUMB_TITLE'),
      icon: <HomeIcon />,
      active: currentPage === routingTypes.DASH,
      clickHandler: bindRouteAction(routingActions.goDash),
    },
    {
      name: 'wellbeing',
      title: getString('drawer', 'WELLBEING_TITLE'),
      breadcrumbTitle: getString('drawer', 'WELLBEING_BREADCRUMB_TITLE'),
      icon: <WellbeingIcon />,
      active:
        currentPage === routingTypes.WELLBEING_LANDING ||
        currentPage === routingTypes.WELLBEING_CHILD,
      clickHandler: bindRouteAction(routingActions.goWellbeingLanding),
    },
    {
      name: 'apply',
      title: getString('drawer', 'APPLY_TITLE'),
      breadcrumbTitle: getString('drawer', 'APPLY_BREADCRUMB_TITLE'),
      icon: <ApplyIcon />,
      active:
        currentPage === routingTypes.APPLICATION_LANDING ||
        currentPage === routingTypes.APPLICATION_CHILD,
      clickHandler: bindRouteAction(routingActions.goApplicationLanding),
    },
    {
      name: 'accounts',
      title: getString('drawer', 'ACCOUNTS_TITLE'),
      breadcrumbTitle: getString('drawer', 'ACCOUNTS_BREADCRUMB_TITLE'),
      icon: <AccountsIcon />,
      active: currentPage === routingTypes.ACCOUNTS,
      clickHandler: bindRouteAction(routingActions.goAccounts),
      role: constants.ROLE_ACCOUNT_READ,
    },
    {
      name: 'maintenance',
      title: getString('drawer', 'MAINTENANCE_TITLE'),
      breadcrumbTitle: getString('drawer', 'MAINTENANCE_BREADCRUMB_TITLE'),
      icon: <MaintenanceIcon />,
      active:
        currentPage === routingTypes.WORK_REQUESTS ||
        currentPage === routingTypes.WORK_REQUESTS_CREATE,
      clickHandler: bindRouteAction(routingActions.goWorkRequests),
      role: constants.ROLE_REQUEST_READ,
    },
    {
      name: 'appointments',
      title: appointmentsTitle,
      breadcrumbTitle: getString('drawer', 'APPOINTMENTS_BREADCRUMB_TITLE'),
      icon: <AppointmentsIcon />,
      active: currentPage === routingTypes.APPOINTMENTS,
      clickHandler: bindRouteAction(routingActions.goAppointments),
      role: constants.ROLE_APPOINTMENTS_READ,
    },
    {
      name: 'profile',
      title: getString('drawer', 'PROFILE_TITLE'),
      breadcrumbTitle: getString('drawer', 'PROFILE_BREADCRUMB_TITLE'),
      icon: <ProfileIcon />,
      active: currentPage === routingTypes.PROFILE,
      clickHandler: bindRouteAction(routingActions.goProfile),
      role: constants.ROLE_CUSTOMER_READ,
    },
    {
      name: 'letters',
      title: lettersTitle,
      breadcrumbTitle: getString('drawer', 'LETTERS_BREADCRUMB_TITLE'),
      icon: <LettersIcon />,
      active: currentPage === routingTypes.LETTERS,
      clickHandler: bindRouteAction(routingActions.goLetters),
      role: constants.ROLE_CUSTOMER_READ,
    },
    {
      name: 'services',
      title: getString('drawer', 'SERVICES_TITLE'),
      breadcrumbTitle: getString('drawer', 'SERVICES_BREADCRUMB_TITLE'),
      icon: <ServicesIcon />,
      active:
        currentPage === routingTypes.SERVICE_LANDING ||
        currentPage === routingTypes.SERVICE_CHILD,
      clickHandler: bindRouteAction(routingActions.goServiceLanding),
      role: constants.ROLE_CUSTOMER_READ,
    },
    {
      name: 'contact',
      title: getString('drawer', 'CONTACT_TITLE'),
      breadcrumbTitle: getString('drawer', 'CONTACT_BREADCRUMB_TITLE'),
      icon: <PhoneIcon />,
      active: currentPage === routingTypes.CONTACT,
      clickHandler: bindRouteAction(routingActions.goContact),
    },
    !isFeatureDisabled('HELP_CENTER')
      ? {
          name: 'help',
          title: getString('drawer', 'HELP_TITLE'),
          breadcrumbTitle: getString('drawer', 'HELP_BREADCRUMB_TITLE'),
          icon: <HelpIcon />,
          active: currentPage === routingTypes.HELP_CENTER,
          clickHandler: bindRouteAction(routingActions.goHelpCenter),
        }
      : null,
    null,
  ];
}

export default configureDrawerMap;
